import React, { Suspense } from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import './i18n';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false
        }
    }
});

// use with strictmode will resulting hooks like useReducer dispatcher to run twice
// ReactDOM.render(
//   <React.StrictMode>
//       <Suspense fallback={"loading"}>
//           <QueryClientProvider client={queryClient}>
//               <App/>
//           </QueryClientProvider>
//       </Suspense>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

const rootElm = document.getElementById('app-org');
const root = createRoot(rootElm);

root.render(
    <Suspense fallback={<div className="root"/>}>
        <QueryClientProvider client={queryClient}>
            <App/>
        </QueryClientProvider>
    </Suspense>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
